"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.7 5.217a3.26 3.26 0 0 0-3.4 0c-1.8 1.1-4.27 2.626-5.39 3.38a1.144 1.144 0 0 0 0 1.899l4.77 3.209q.056.03.106.071l.54.364a3 3 0 0 0 3.348 0l.539-.362a1 1 0 0 1 .11-.074l4.768-3.208a1.145 1.145 0 0 0 0-1.9m-4.52 6.628-.115.077a4.4 4.4 0 0 1-4.91 0l-.116-.077-3.782 3.782a2.3 2.3 0 0 0 1.053.256H17.3c.38 0 .738-.093 1.054-.256zm4.772 2.792-3.589-3.588L19.6 11.84v5.12c0 .38-.093.74-.256 1.055m1.653-8.535a2.53 2.53 0 0 0-1.123-2.046c-1.152-.774-3.652-2.317-5.442-3.412a4.66 4.66 0 0 0-4.862 0C7.78 5.118 5.28 6.66 4.13 7.435M20.995 9.48l.003.065v7.416a3.7 3.7 0 0 1-3.7 3.7H6.7a3.7 3.7 0 0 1-3.7-3.7V9.546q0-.036.004-.072c.022-.78.396-1.55 1.123-2.04m.273 4.407v5.12c0 .381.093.74.256 1.056l3.59-3.59zm9.3-6.624c1.798 1.1 4.27 2.626 5.39 3.38z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EmailOpenIcon24.js.map